import React, { useMemo } from "react";

import { i18nService } from "services";

import { Modal } from "components/modal/Modal";
import { Button } from "components/button/Button";

interface MobileFacetsProps {
  handleClose: () => void;
  renderFacets: () => JSX.Element;
  mobileTitle?: string;
  nbResults?: number;
  isLoading?: boolean;
}

export const MobileFacets: React.FC<MobileFacetsProps> = ({
  handleClose,
  renderFacets,
  mobileTitle,
  nbResults,
  isLoading,
}) => {
  const copyKey = useMemo(() => {
    if (nbResults === 1) {
      return "facets.showResultsSingular";
    }

    if (!nbResults) {
      return "facets.noResults";
    }

    return "facets.showResults";
  }, [nbResults]);

  return (
    <>
      <Modal theme="light" handleClose={handleClose}>
        <div className="mobile-facets__content">
          {mobileTitle && (
            <h2 className="mobile-facets__title">{mobileTitle}</h2>
          )}
          {renderFacets()}
          <div className="mobile-facets__sticky-button">
            <Button
              isLoading={isLoading}
              layout="block"
              text={i18nService.copy[copyKey]?.replace(
                "@number",
                String(nbResults)
              )}
              onClick={handleClose}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
